import {
  VIDEO_FULLSCREEN_ACTIVE,
  VIDEO_FULLSCREEN_INACTIVE
} from '../actions/types';

const INITIAL_STATE = {
  isFullScreen: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VIDEO_FULLSCREEN_ACTIVE:
      return {
        isFullScreen: true
      };
    case VIDEO_FULLSCREEN_INACTIVE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
